import { render, staticRenderFns } from "./targetsalesfrm.vue?vue&type=template&id=25c87cef"
import script from "./targetsalesfrm.vue?vue&type=script&lang=js"
export * from "./targetsalesfrm.vue?vue&type=script&lang=js"
import style0 from "./targetsalesfrm.vue?vue&type=style&index=0&id=25c87cef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports